import React, { useEffect, useRef } from 'react';
import './index.css';
import Navbar from '../Navbar';

// Import your service images here
import heroImage from '../../assests/scope-hero.png';
import architecturalIcon from '../../assests/architectural-design-icon.png';
import interiorIcon from '../../assests/interior-design-icon.png';
import layoutIcon from '../../assests/layout-planning-icon.png';
import service4Icon from '../../assests/approval-drawings-icon.png';
import service5Icon from '../../assests/service5-icon.png';
import service6Icon from '../../assests/service6-icon.png';
import service7Icon from '../../assests/service7-icon.png';
import service8Icon from '../../assests/service8-icon.png';

const Scope = () => {

  // Refs for scroll reveal
  const heroImageRef = useRef(null);
  const heroTextRef = useRef(null);
  const servicesTitleRef = useRef(null);
  const servicesGridRef = useRef(null);
  const ctaRef = useRef(null);

  // Services data array
  const services = [
    {
      id: 1,
      icon: architecturalIcon,
      title: 'ARCHITECTURAL DESIGN',
      description: 'Innovative and contextual design solutions that bring balance between form, function, and environment.'
    },
    {
      id: 2,
      icon: interiorIcon,
      title: 'INTERIOR DESIGN & DETAILING',
      description: 'Personalized interiors that elevate lifestyle and enhance everyday experiences through detail, texture, and atmosphere.'
    },
    {
      id: 3,
      icon: layoutIcon,
      title: 'LAYOUT & MASTER PLANNING',
      description: 'Comprehensive site strategies that integrate architecture, landscape, and infrastructure seamlessly.'
    },
    {
      id: 4,
      icon: service4Icon,
      title: 'Approval Drawings',
      description: 'Preparation of statutory and regulatory drawings as per local rules and development guidelines.'
    },
    {
      id: 5,
      icon: service5Icon,
      title: 'Working & Detail Drawings',
      description: 'Technical documentation and precision drawings to ensure accurate execution at every stage.'
    },
    {
      id: 6,
      icon: service6Icon,
      title: 'Bid Documentation & ontractor Evaluation',
      description: 'End-to-end assistance with tender preparation, bid analysis, and contractor selection.'
    },
    {
      id: 7,
      icon: service7Icon,
      title: 'Cost & Variance Analysis',
      description: 'Budget forecasting, comparative cost studies, and monitoring to maintain financial clarity throughout the project.'
    },
    {
      id: 8,
      icon: service8Icon,
      title: 'Site Coordination',
      description: 'Regular stage-wise visits, quality checks, and coordination with consultants to ensure timely, flawless delivery.'
    },
  ];



  // Intersection Observer for Scroll Reveal
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-visible');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe all sections
    const sections = [
      heroImageRef.current,
      heroTextRef.current,
      servicesTitleRef.current,
      servicesGridRef.current,
      ctaRef.current
    ];

    sections.forEach(section => {
      if (section) {
        observer.observe(section);
      }
    });

    // Cleanup
    return () => {
      sections.forEach(section => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  return (
    <div className="scopepage-container">
      {/* Shared Navigation Header */}
      <Navbar />

      {/* Main Content */}
      <main className="scopepage-main">
        {/* Hero Section - Image Left, Text Right */}
        <section className="scopepage-hero">
          <div
            ref={heroImageRef}
            className="scopepage-hero-image-container reveal-section reveal-left"
          >
            <img src={heroImage} alt="Interior Design" className="scopepage-hero-image" />
          </div>

          <div
            ref={heroTextRef}
            className="scopepage-hero-text-container reveal-section reveal-right"
          >
            <h1 className="scopepage-hero-title">
              DESIGN THAT <span className="scopepage-hero-title-bold">TRANSFORMS</span> VISION INTO EXPERIENCE
            </h1>

            <div className="scopepage-hero-description">
              <p>
                From architecture to interiors, every service we offer is built on one belief <br className="desktop-br" />—great design goes beyond aesthetics. It's about function, context, and <br className="desktop-br" /> the seamless collaboration that brings a project from concept to <br className="desktop-br" /> completion. At Lavanya & Shankar, we offer a holistic, single-point <br className="desktop-br" /> approach—blending creativity, technical precision, and management <br className="desktop-br" /> expertise into one cohesive journey.
              </p>
            </div>
          </div>
        </section>

        {/* What We Do Section */}
        <section className="scopepage-services">
          <h2
            ref={servicesTitleRef}
            className="scopepage-services-title reveal-section reveal-fade"
          >
            WHAT WE DO
          </h2>

          <div
            ref={servicesGridRef}
            className="scopepage-services-grid reveal-section"
          >
            {services.map((service, index) => (
              <div
                key={service.id}
                className="scopepage-service-card reveal-scale"
                style={{
                  transitionDelay: `${index * 0.1}s`
                }}
              >
                <div className="scopepage-service-icon-container">
                  <img src={service.icon} alt={service.title} className="scopepage-service-icon" />
                </div>
                <h3 className="scopepage-service-title">{service.title}</h3>
                <p className="scopepage-service-description">{service.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Let's Build Together CTA */}
        <section
          ref={ctaRef}
          className="build-together-cta reveal-section reveal-scale"
        >
          <div className="build-together-cta__content">
            <h2 className="build-together-cta__title">Beyond Architecture</h2>
            <div className="beyond-build-together-cta__text">
              <p>
                Every service we provide is guided by empathy, context, and commitment. Whether we're designing <br /> a private residence, an institution, or a commercial space, our process remains constant  <br /> —listen deeply, think critically, and craft spaces that stand the test of time. <br />For us, design isn't just what we do—it's how we build belonging.
              </p>
            </div>
            {/* <Link to="/contact" className="build-together-cta__button">
              START A CONVERSATION
            </Link> */}
          </div>
        </section>
      </main>
    </div>
  );
};

export default Scope;